export function handleDetermineNanosInDuration(duration: string | { nanos: number; seconds: number }) {
  let includeNanos: boolean = false;
  if ((duration as any)?.nanos || (duration as any)?.seconds) {
    includeNanos = true;
  }
  return includeNanos;
}

export interface DurationInput {
  includeNanos: boolean;
  seconds: string; // min 0
  nanos: string; // min 0
}

export function inputToDuration(input: DurationInput) {
  if (input.includeNanos) {
    return {
      seconds: Number(input.seconds),
      nanos: Number(input.nanos),
    };
  } else {
    return `${input.seconds}s`;
  }
}
